import { defineComponent } from '~/scripts/utils/alpine'
import CampusImagesTween from '~/scripts/embla/plugins/campus-images-tween'

export default defineComponent(() => ({
  campusImagesTween: CampusImagesTween(),
}))
